import { render, staticRenderFns } from "./lanpoorten.vue?vue&type=template&id=5f993f8c&scoped=true"
import script from "./lanpoorten.vue?vue&type=script&lang=js"
export * from "./lanpoorten.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f993f8c",
  null
  
)

export default component.exports